import React from 'react';
import { MonthConvert, MonthConvert_year } from './utility'
const trimesters = {
  "first": 'First Trimester',
  'second': 'Second Trimester',
  'third': 'Third Trimester'
}
function PeriodTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <>
      <table >
        <thead>
          <tr>
            <th >Menstrual Cycle</th>
            <th >Most Probable Ovulation Days</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, index) => (
            <tr className="">
              <td>{MonthConvert(item.startDatePeriods)} - {MonthConvert(item.endDatePeriods)}</td>
              <td>{MonthConvert(item.ovulationWindowStart)} - {MonthConvert(item.ovulationWindowEnd)}</td>
            </tr>
          ))}
        </tbody>
      </table>
     </>
    );
  }
}
function OvulationTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <>
      <table >
        <thead>
          <tr className='highlightedOk'>
            <th className="">Status</th>
            <th className="">Results</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Most Probable Ovulation Date</td>
            <td>{MonthConvert_year(result.mostProbableOvulationDate)}</td>
          </tr>
          <tr>
            <td>Intercourse Window for Pregnancy</td>
            <td>{MonthConvert_year(result.intercourseWindowForPregnancy)}</td>
          </tr>
          <tr>
            <td>Pregnancy Test Date</td>
            <td>{MonthConvert_year(result.pregnancyTest)}</td>
          </tr>
          <tr>
            <td>Next Menstrual Cycle Start Date</td>
            <td>{MonthConvert_year(result.nextPeriodStart)}</td>
          </tr>
          <tr>
            <td>Due Date If Pregnant</td>
            <td>{MonthConvert_year(result.dueDateIfPregnant)}</td>
          </tr>
        </tbody>
      </table>
      </>
    )
  }
}
function OvulationTableV2({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    const response = result.importantDatesForNextSixMonths
    return (
      <>
      <table >
        <thead>
          <tr>
            <th >Next Menstrual Cycle Start</th>
            <th >Ovulation Window</th>
            <th >Expected Due Date</th>
          </tr>
        </thead>
        <tbody>
          {response.map((item, index) => (
            <tr className="">
              <td>{MonthConvert_year(item.startDatePeriods)}</td>
              <td>{MonthConvert_year(item.ovulationWindowStart)} - {MonthConvert_year(item.ovulationWindowEnd)}</td>
              <td>{MonthConvert_year(item.dueDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </>
    );
  }
}
function ConceptionTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (
      <>
      <table >
        <thead>
          <tr>
            <th >Next Menstrual Cycle Start</th>
            <th >Conception Window</th>
            <th >Expected Due Date</th>
          </tr>
        </thead>
        <tbody>
          {result.map((item, index) => (
            <tr className="">
              <td>{MonthConvert_year(item.startDatePeriods)}</td>
              <td>{MonthConvert_year(item.conceptionWindowStart)} - {MonthConvert_year(item.conceptionWindowEnd)}</td>
              <td>{MonthConvert_year(item.dueDate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      </>
    );
  }
}
function PregnancyTable({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = result;
    return (
      <>
      <table >
        <thead>
          <tr>
            <th >Status</th>
            <th >Results</th>
          </tr>
          <tr>
            <td > You are in week number </td>
            <td > {response.currentWeek} ({response.numberOfWeeks} weeks and {response.remainingDays} days <b>or</b> {response.months} months and {response.daysMonth} days)</td>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <td>Estimated Due Date is</td>
            <td>{MonthConvert_year(response.dueDate)} </td>
          </tr>
          <tr className="">
            <td>Most likely conception date is</td>
            <td>{MonthConvert_year(response.conceivedDate)} </td>
          </tr>
          <tr className="">
            <td> You are in</td>
            <td>{trimesters[response.trimstre]} </td>
          </tr>
          <tr className="">
            <td> You have completed</td>
            <td>{response.percentageOfPregnancyTime}%  of the pregnancy period</td>
          </tr>
        </tbody>
      </table>
      </>
    );
  }
}
function PregnancyWeightTable({ Response, WeightBeforePregnancy }) {
  if (Response === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = Response;
    var range = ""
    var bmi = ''
    if (response.weightclassification === 'higher') { range = "Your current weight is higher than recommended." }
    if (response.weightclassification === 'lower') { range = "Your current weight is lower than recommended." }
    if (response.weightclassification === 'normal') { range = "Your current weight is in the recommended range." }
    if (response.bmiResult.BMIclassification === 'Underweight') { bmi = 'Underweight' }
    if (response.bmiResult.BMIclassification === 'Normal weight') { bmi = 'Normal weight' }
    if (response.bmiResult.BMIclassification === 'Overweight') { bmi = 'Pre-obese' }
    if (response.bmiResult.BMIclassification === 'Obese') { bmi = 'Obese' }
    return (
      <>
      <table >
        <thead>
          <tr>
            <td > Recommended Weight Range for Week {response.week} </td>
            <td > <b>{response.recommended.max}</b> - <b>{response.recommended.min}</b></td>
          </tr>
        </thead>
        <tbody>
          <tr className="">
            <td>Recommended Weight Range at Delivery (Week 40)</td>
            <td><b>{response.recommendedWeightDelivering.max}</b> - <b>{response.recommendedWeightDelivering.min}</b></td>
          </tr>
          <tr className={response.bmiResult.BMIclassification}>
            <td> <b>({bmi})</b> Body Mass Index (BMI)</td>
            <td><b>{response.bmiResult.BMI}</b> kg/m²&nbsp;</td>
          </tr>
          <tr className="">
            <td colSpan="3">
              {range}</td>
          </tr>
        </tbody>
      </table>
      </>
    );
  }
}
function PregnancyWeight50Table({ Response, WeightBeforePregnancy }) {
  if (Response === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = Response;
    if (response.weightclassification === 'higher') 
    if (response.weightclassification === 'lower') 
    if (response.weightclassification === 'normal') 
    if (response.bmiResult.BMIclassification === 'Underweight') 
    if (response.bmiResult.BMIclassification === 'Normal weight') 
    if (response.bmiResult.BMIclassification === 'Overweight') 
    if (response.bmiResult.BMIclassification === 'Obese') 
    return (
      <table >
        <thead>
          <tr>
            <td className='bmi-header'>Week</td>
            <td className='bmi-header'>Recommended Weight Range</td>
            <td className='bmi-header'>Recommended Weight Gain</td>
          </tr>
        </thead>
        <tbody>
          {response.maxWeightValues.map((item, index) => (
            <tr className="">
              <td>Week {index + 1}</td>
              <td>{WeightBeforePregnancy + response.minWeightValues[index]} - {WeightBeforePregnancy + response.maxWeightValues[index]}</td>
              <td>{response.minWeightValues[index]} - {response.maxWeightValues[index]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}
function ConceptionTablev2({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    let response = result;
    return (
      <table >
        <thead>
          <th >Status</th>
          <th >Results</th>
          <tr>
            <td>Most Probable Conception Dates</td>
            <td> {MonthConvert_year(response.mostProbableConceptionWindowStart)} to {MonthConvert_year(response.mostProbableConceptionWindowEnd)} </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Most Probable Sexual Intercourse Dates Leading to Pregnancy</td>
            <td> {MonthConvert_year(response.mostProbableDatesSexualIntercourseStart)} to {MonthConvert_year(response.mostProbabledatesSexualIntercourseEnd)} </td>
          </tr>
          <tr>
            <td>Possible Conception Dates</td>
            <td> {MonthConvert_year(response.possibleConceptionWindowStart)} to {MonthConvert_year(response.possibleConceptionWindowEnd)} </td>
          </tr>
          <tr>
            <td>
              Possible Sexual Intercourse Dates Leading to Pregnancy:
            </td>
            <td>
              {MonthConvert_year(response.possibleDatesSexualIntercourseStart)} to {MonthConvert_year(response.possibleDatesSexualIntercourseEnd)}
            </td></tr>
        </tbody>
      </table>
    );
  }
}
function OvulationTableFull({ result }) {
  if (result === null) {
    return (
      <div>
      </div>
    )
  }
  else {
    return (<div className="col">
      <p>Important Dates for this Cycle:</p>
      <OvulationTable result={result}></OvulationTable>
      <br></br>
      <br></br>
      <p>Important Dates for the Next Six Cycles:</p>
      <OvulationTableV2 result={result}></OvulationTableV2>
    </div>)
  }
}
function DueDateTable({ result }) {
    return (
      <>
      <table >
      <thead>
        <tr>
          <th >Status</th>
          <th >Results</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td> Estimated Due Date</td>
          <td>{MonthConvert_year(result.dueDate)} </td>
        </tr>
        <tr >
          <td>You are in</td>
          <td> Week {result.currentWeek} ({result.numberOfWeeks} weeks and {result.remainingDays} days or {result.months} months and {result.daysMonth} days) of pregnancy. </td>
        </tr>
        <tr >
          <td>You are in</td>
          <td> {trimesters[result.trimstre]} of pregnancy</td>
        </tr>
        <tr >
          <td>You have completed</td>
          <td> {result.percentageof40week}% of the total pregnancy period</td>
        </tr>
      </tbody>
    </table>
    </>
    )
}
export { DueDateTable,PeriodTable, ConceptionTable, OvulationTable, PregnancyTable, PregnancyWeightTable, PregnancyWeight50Table, ConceptionTablev2, OvulationTableV2, OvulationTableFull };
